<template>
    <div class="maintenance-container">
        <!-- <div class="maintenance-head">
            <div class="maintenance-head-item" v-for="(item, index) in headerList" :key="index">
                <span class="maintenance-head-item-name">{{ item.name }}</span>
                <span class="maintenance-head-item-number">{{ item.number }}</span>
                <span class="maintenance-head-item-unit">{{ item.unit }}</span>
            </div>
        </div> -->
        <div class="maintenance-body">
            <div class="maintenance-body-3D_pie">
                <div class="maintenance-head">
                    <div class="maintenance-head-item">
                        <span class="maintenance-head-item-name">总维护事件</span>
                        <span class="maintenance-head-item-number">{{ totalDevice }}</span>
                        <span class="maintenance-head-item-unit">件</span>
                    </div>
                </div>
                <div class="maintenance-body-3D_pie-tab">
                    <el-carousel ref="title_carousel" arrow="never" v-if="titleList.length > 0" :autoplay="false" type="card" height="50px" @change="activeChange">
                        <el-carousel-item v-for="(item, index) in titleList" :key="index">
                            <span :class="{ isActive: curTabIndex === index }" class="item">{{
                            item.typeName
                          }}</span>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="maintenance-body-3D_pie-chart">
                    <div class="current_count" v-if="titleList.length > 0">
                        总数:
                        <span style="font-size: 25px">{{
                          titleList[curTabIndex].total
                        }}</span>
                        个
                    </div>
                    <div id="3D_chart" @click="openDialog('维护事件')" class="current_chart"></div>
                    <div class="left_btn" @click="prevClick"></div>
                    <div class="right_btn" @click="nextClick"></div>
                </div>
            </div>
            <div class="pie_wrap">
                <div class="maintenance-head">
                    <div class="maintenance-head-item">
                        <span class="maintenance-head-item-name">问题处理</span>
                        <span class="maintenance-head-item-number">{{ totalList[0] }}</span>
                        <span class="maintenance-head-item-unit">件</span>
                    </div>
                </div>
                <div @click="openDialog('问题处理')" id="2D_chart1" class="maintenance-body-2D_pie"></div>
            </div>
            <div class="pie_wrap">
                <div class="maintenance-head">
                    <div class="maintenance-head-item">
                        <span class="maintenance-head-item-name">保养校准</span>
                        <span class="maintenance-head-item-number">{{ totalList[1] }}</span>
                        <span class="maintenance-head-item-unit">件</span>
                    </div>
                </div>
                <div @click="openDialog('保养校准')" id="2D_chart2" class="maintenance-body-2D_pie"></div>
            </div>
            <div class="pie_wrap">
                <div class="maintenance-head">
                    <div class="maintenance-head-item">
                        <span class="maintenance-head-item-name">日常巡检</span>
                        <span class="maintenance-head-item-number">{{ totalList[2] }}</span>
                        <span class="maintenance-head-item-unit">件</span>
                    </div>
                </div>
                <div @click="openDialog('日常巡检')" id="2D_chart3" class="maintenance-body-2D_pie"></div>
            </div>
            <div class="legend-list">
                <div class="legend" v-for="(item, index) in legendList" :key="index">
                    <div class="point" :style="{background: item.color}"></div>
                    <div class="name">{{ item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import {
    ref,
    reactive,
    onMounted,
    nextTick,
    onBeforeMount,
    onUnmounted,
    getCurrentInstance
} from "vue";
import get3Dpie from "./charts/3D_pieChart.js";
import get2Dpie from "./charts/2D_pieChart.js";
import HighCharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import jsonData from "/public/static/js/json/operatieCenter.json";
import { useRouter, useRoute } from 'vue-router'
Highcharts3D(HighCharts);

export default {
    setup (props, context) {
        console.log('context', context)
        const { ctx } = getCurrentInstance()
        let route = useRouter()
        console.log("路由", route.currentRoute._rawValue.path)
        console.log("测试111", 221)
        // 大标题list
        const headerList = reactive([]);

        // 小标题list
        // const titleList = reactive([]);

        // 标题走马灯组件
        const title_carousel = ref(null);
        // 当前标题索引
        const curTabIndex = ref(0);
        const show3dPie = ref(true)

        const canvasList = ref([]);

        let totalEquipment = ref({});

        // 3D饼图数据
        let status3DOpt = reactive([]);

        let problemSolve = reactive([]);
        let maintainCalibration = reactive([]);
        let dailyPatrol = reactive([]);
        const get2DData = () => {
            jsonData.maintenanceData.dailyData.forEach((item) => {
                if (item.name === "问题处理") {
                    problemSolve.value = item.data;
                }
                if (item.name === "保养校准") {
                    maintainCalibration.value = item.data;
                }
                if (item.name === "日常巡检") {
                    dailyPatrol.value = item.data;
                }
            });
            console.log("1231", problemSolve.value, maintainCalibration.value, dailyPatrol.value);
        };

        // get2DData()

        const getHeadList = () => {
            headerList.push({
                name: jsonData.maintenanceData.totalEquipment.name,
                number: jsonData.maintenanceData.totalEquipment.count,
                unit: "件",
            });
            jsonData.maintenanceData.dailyData.forEach((item) => {
                headerList.push({
                    name: item.name,
                    number: item.count,
                    unit: "件",
                });
            });
        };

        getHeadList()

        // const getTitleList = () => {
        //     jsonData.maintenanceData.totalEquipment.data.forEach((item) => {
        //         titleList.push({
        //             name: item.name,
        //             count: item.count,
        //         });
        //     });
        // };

        // getTitleList()

        const get3DData = () => {
            status3DOpt = [];
            status3DOpt.push({
                type: "pie",
                name: "占比",
                data: jsonData.maintenanceData.totalEquipment.data[curTabIndex.value].data,
            });
            console.log("status3DOpt", status3DOpt);
        };



        const activeChange = (activeIndex) => {
            curTabIndex.value = activeIndex;
            // $(".current_chart").highcharts().destroy();
            // get3DData();
            // HighCharts.chart("3D_chart", get3Dpie(status3DOpt));
        };

        const prevClick = () => {
            title_carousel.value.prev();
            // console.log($(".tab_Item"));
            // get3DData();
        };

        const nextClick = () => {
            title_carousel.value.next();
            // nextTick(() => {
            //   console.log(title_carousel, "title_carousel");
            // });
            // get3DData();
        };

        console.log("999", context)

        const initCharts = function () {
            let list = [1, 2, 3]
            console.log('canvasList', canvasList.value, canvasList.value.length)
            list.forEach((ele, index) => {
                console.log("999", ele, index)
                switch (index) {
                    case 0:
                        console.log(document.getElementById("2D_chart1"), 1111)
                        echarts
                            .init(document.getElementById("2D_chart1"))
                            .setOption(get2Dpie(problemSolve.value, "问题处理", false));
                        break;
                    case 1:
                        echarts
                            .init(document.getElementById("2D_chart2"))
                            .setOption(get2Dpie(maintainCalibration.value, "保养校准", false));
                        break;
                    case 2:
                        echarts
                            .init(document.getElementById("2D_chart3"))
                            .setOption(get2Dpie(dailyPatrol.value, "日常巡检", false));
                        break;
                }
            });


        }
        console.log("1212", route.currentRoute._rawValue.path)
        // if (route.currentRoute._rawValue.path == "/operationCenterMod") {
        //   initCharts()
        // }
        get3DData()
        onMounted(() => {
            initCharts()
            // HighCharts.chart("3D_chart", get3Dpie(status3DOpt));
        })


        return {
            nextClick,
            prevClick,
            activeChange,
            headerList,
            title_carousel,
            curTabIndex,
            canvasList,
            totalEquipment,
            status3DOpt,
            problemSolve,
            maintainCalibration,
            dailyPatrol,
            show3dPie
        };
    },

    data () {
        return {
            titleList: [],
            totalList: [],
            totalDevice: '',
            legendList: [],
            deviceTypeList: []
        }
    },

    created () {
        this.getTypeListByCustomerId()
    },
    mounted () {
        this.checkTaskInfo()
        
    },
    watch: {
        curTabIndex (val, old) {
            console.log('val', val)
            this.get3DData()
        }
    },

    methods: {
        openDialog (item) {
            let num = 0
            if (item == "问题处理") {
                num = this.totalList[0]
            } else if (item == '保养校准') {
                num = this.totalList[1]
            } else if (item == '日常巡检') {
                num = this.totalList[2]
            } else if (item == '维护事件') {
                num = this.totalDevice
            } 
            this.$store.commit("upDateOperationCenterDialog", { state: true, params: { type: item, value: num } });
        },
        // 厂家设备统计信息
        async checkTaskInfo () {
            let that = this
            let url =
                CONFIG.requestName + this.$apiOpt.deviceStatisticsInfo;
            await this.$apiUtils
                .get(url, {
                    customerId: this.$store.state.customerId,
                })
                .then(function (data) {

                    that.titleList = data.deviceInfoList
                    that.totalDevice = data.total
                    that.get3DData()
                });
        },

        // 设备类型列表
        async getTypeListByCustomerId () {
            let that = this
            let url =
                CONFIG.requestName + this.$apiOpt.getTypeListByCustomerId;
            await this.$apiUtils
                .get(url, {
                    customerId: this.$store.state.customerId,
                })
                .then(function (data) {
                    let colorArr = ['#0438a1', '#0797fa', '#9feffd', '#4ab99c', '#f5c85f', '#fffca8', '#f05422', '#4cd2ec', '#f79ffd', '#f38a54', '#d63e7c', '#fffca8','#9755fb', '#fb6355', '#fffee6']
                    for (let i = 0; i< data.length; i++) {
                        if (colorArr[i]) {
                            console.log("123",data[i])
                            data[i].color = colorArr[i]
                        }
                    }
                    that.deviceTypeList = data
                    let p1 = that.get2DData(1)
                    let p2 = that.get2DData(2)
                    let p3 = that.get2DData(3)
                    Promise.all([p1, p2, p3]).then((result) => {
                        const map = new Map();
                        that.legendList = that.legendList.filter(v => !map.has(v.name) && map.set(v.name, 1));
                    }).catch((error) => {
                        console.log(error)      // 失败了，打出 '失败'
                    })
                });
        },

        get2DData (id) {
            let that = this
            let url =
                CONFIG.requestName + this.$apiOpt.deviceStatisticsCustomer;
            return new Promise((resolve, reject) => {
            this.$apiUtils
                .get(url, {
                    customerId: this.$store.state.customerId,
                    typeId: id
                })
                .then(function (data) {
                    resolve(data.deviceInfoList)
                    let value = []
                    console.log("2131", that.deviceTypeList)
                    if (data.deviceInfoList && data.deviceInfoList.length > 0) {
                        for (let item of data.deviceInfoList) {
                            for (let val of that.deviceTypeList) {
                                if (val.typeName == item.typeName) {
                                    value.push({
                                        name: item.typeName,
                                        value: item.total,
                                        color: val.color
                                    })
                                }
                            }
                            
                        }
                    }
                    that.legendList = that.legendList.concat(value)
                    console.log('legendList',that.legendList)

                    if (id == 3) {
                        that.totalList[0] = data.total
                        echarts
                            .init(document.getElementById("2D_chart1"))
                            .setOption(get2Dpie(value, "问题处理", false));
                    } else if (id == 2) {
                        that.totalList[1] = data.total
                        echarts
                            .init(document.getElementById("2D_chart2"))
                            .setOption(get2Dpie(value, "保养校准", false));
                    } else if (id == 1) {
                        that.totalList[2] = data.total
                        echarts
                            .init(document.getElementById("2D_chart3"))
                            .setOption(get2Dpie(value, "日常巡检", false));
                    }
                })
            })
        },

        get3DData () {
            let that = this
            let url =
                CONFIG.requestName + this.$apiOpt.taskStatisticsInfo;
            this.$apiUtils
                .get(url, {
                    customerId: this.$store.state.customerId,
                    typeId: this.titleList[this.curTabIndex].typeId
                })
                .then(function (data) {
                    let val = [
                        [
                            "问题处理",
                            data.problemTotal
                        ],
                        [
                            "日常巡查",
                            data.dailyTotal
                        ],
                        [
                            "保养校准",
                            data.correctTotal
                        ]
                    ]
                    // if (data.problemTotal) {
                    //     val.push([
                    //         "问题处理",
                    //         data.problemTotal
                    //     ])
                    // } else if (data.dailyTotal){
                    //     val.push([
                    //         "日常巡查",
                    //         data.dailyTotal
                    //     ])
                    // } else if (data.dailyTotal){
                    //     val.push([
                    //         "保养校准",
                    //         data.correctTotal
                    //     ])
                    // }
                    if (data.problemTotal === 0 && data.dailyTotal === 0 && data.correctTotal == 0) {
                        that.show3dPie = false
                    } else {
                        that.show3dPie = true
                    }

                    console.log('data1234', data)
                    let status3DOpt = [{
                        type: "pie",
                        name: "占比",
                        data: val,
                    }];
                    // $(".current_chart").highcharts().destroy();
                    HighCharts.chart("3D_chart", get3Dpie(status3DOpt));
                });
        }
    }
}


</script>

<style lang="scss" scoped>
.maintenance {
    transition: none 0s ease 0s;

    &-container {
        width: 100%;
        height: 100%;
    }
    &-head {
        height: 80px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        font-size: 25px;
        &-item-number {
            font-size: 50px;
            margin: 0 20px;
            color: #38c5ec;
            font-family: "yjsz";
            letter-spacing: 2px !important;
        }
    }
    &-body {
        // height: calc(100% - 80px);
        height: 100%;
        padding: 10px 30px 20px 60px;
        display: flex;
        justify-content: space-between;
        &-3D_pie {
            width: 25%;
            height: 270px;
            &-tab {
                width: 100%;
                height: 50px;
                position: relative;
                overflow: hidden;
                // display: flex;
                // align-items: center;
                // justify-content: space-between;
                // overflow: hidden;
                // flex-wrap: wrap;
                .tab_container {
                    width: 120% !important;
                    // background-color: #fff;
                    height: 50px;
                    .tab_Item {
                        display: inline-block;
                        width: 20%;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        font-size: 13px;
                    }
                }
            }
            &-chart {
                position: relative;
                height: calc(100% - 50px);
                .left_btn,
                .right_btn {
                    position: absolute;
                    width: 50px;
                    height: 120px;
                    top: 50px;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
                .left_btn {
                    left: 0;
                    background-image: url("./img/left_button.png");
                }
                .right_btn {
                    right: 0;
                    background-image: url("./img/right_button.png");
                }
            }
        }
        &-2D_pie {
            width: 100%;
            height: 100%;
        }
    }
}
:deep(.el-carousel__mask) {
    background-color: transparent !important;
}
:deep(.el-carousel__indicators--outside) {
    opacity: 0;
}
.pie_wrap {
    display: flex;
    flex-direction: column;
    width: 23%;
    align-items: center;
    &:last-child {
        .maintenance-head {
            //   margin-left: -200px;
          }
    }
}
.item {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 50px;
    font-style: italic;
}
.isActive {
    font-size: 25px;
    color: #31bff7;
    font-weight: 700;
}
.current_count {
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-weight: 700;
    font-size: 16px;
    font-style: italic;
}
.current_chart {
    height: 200px;
}

.legend-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 220px;
    .legend {
        display: flex;
        margin-bottom: 3px;
        align-items: center;
        .point {
            width: 16px;
            height: 16px;
            background: #fff;
            margin-right: 10px;
            border-radius: 10px;
        }
        .name {
            font-size: 20px;
            color: #f4f4f4;
        }
    }
}
</style>
